export enum BookingsPollingStatusEnum {
  Initializing = "Initializing",
  InProgress = "InProgress",
  Completed = "Completed",
  Error = "Error",
  ConflictError = "ConflictError",
  Aborted = "Aborted",
  Idle = "Idle",
}
